import React from 'react';
import { BRAND, isMarketGB } from '../../../constants/main';
import { BasketScrappageDetailsAC } from './AC/BasketScrappageDetails.AC';
import { BasketScrappageDetailsOV } from './OV/BasketScrappageDetails.OV';
import { BasketScrappageDetailsAP } from './AP/BasketScrappageDetails.AP';
import { BasketScrappageDetailsDS } from './DS/BasketScrappageDetails.DS';
import { BasketScrappageDetailsOV as BasketScrappageDetailsOV_GB } from './OV/GB/BasketScrappageDetails.OV';
import { BasketScrappageDetailsStyled } from './BasketScrappageDetailsStyled';
import { SC } from '../../../styles/theme';

export type BasketScrappageDetailsProps = SC & {
    generatedIndex?: number;
};

const BasketScrappageDetails = (props: BasketScrappageDetailsProps) => {
    if (BRAND === 'AC') return <BasketScrappageDetailsAC {...props} />;
    if (BRAND === 'OV')
        return isMarketGB ? <BasketScrappageDetailsOV_GB {...props} /> : <BasketScrappageDetailsOV {...props} />;
    if (BRAND === 'AP') return <BasketScrappageDetailsAP {...props} />;
    if (BRAND === 'DS') return <BasketScrappageDetailsDS {...props} />;
    return <BasketScrappageDetailsStyled {...props} />;
};

export default BasketScrappageDetails;
